import 'promise-polyfill/src/polyfill';
import load from 'little-loader';

if (!window.polyfillPromise) {
    if (
        Array.prototype.some.call(
            document.head.getElementsByTagName('script'),
            script => script.src && script.src.indexOf('polyfill.io') !== -1
        )
    ) {
        // TODO: remove after polyfill script is removed from head
        window.polyfillPromise = new Promise(r => r());
    } else {
        window.polyfillPromise = loadPolyfill();
    }
}

export default function loadPolyfill() {
    return new Promise<void>(resolve => {
        load(getPolyfillUrl(), err => resolve(err || null));
    });
}

function getPolyfillUrl() {
    const url = 'https://cdn.polyfill.io/v3/polyfill.min.js';
    // const excludes =
    //     'Symbol,Symbol.iterator,Symbol.species,Object.defineProperty';
    const features =
        'default,Intl,Intl.~locale.ru,Array.prototype.includes,WeakSet,Symbol,Symbol.iterator,Symbol.species,Array.prototype.find,Array.prototype.@@iterator,Set,Array.prototype.entries,Object.entries,String.prototype.includes,IntersectionObserver,Function.prototype.name';

    return `${url}?features=${features}&unknown=polyfill&flags=gated`;
}
